jQuery(function ($) {
  console.log("Super Cycle Tiny Human ready");

  // FUNC: CREATE CANVAS HALF CIRCLE
  // CANVAS TINY PEOPLE
  function createGridCanvasWithIcons(canvasId, animationFunction, iconPath) {
    const stickyParent = $($("#" + canvasId).data("parent"));
    const idx = stickyParent.data("idx");
    let pc = 0;
    let completed = false;

    function animateIcons() {
      if (completed) {
        return;
      }

      const vH = $(window).height();
      const target = stickyParent.data("target");
      let topPosition = Math.ceil(
        $("#gridCanvasWrapper")[0].getBoundingClientRect().top * -1
      );

      let pH;
      let full;

      pH = stickyParent.height();

      if (idx > 1) {
        topPosition = topPosition - pH * (idx - 1);
      }

      full = pH - vH;
      pc = Math.ceil((topPosition / full) * 100);

      const pcCutOff = idx === 1 ? 85 : 70;

      // NOTE: When pc reached pcCutOff, animation is complete
      if (pc >= pcCutOff) {
        pc = pcCutOff;
      }

      pc = Math.ceil((pc / pcCutOff) * 100);

      // Calculate animation progress: pc
      let progress = Math.ceil((pc / 100) * target);

      if (progress > 100) {
        progress = 100;
      }

      // if (idx === 1) {
      //   console.log(idx + ' check', topPosition, full, pc + '%', progress);
      // }

      // if (!completed) {
      if (progress > 0 && progress <= target) {
        for (let i = 1; i <= progress; i++) {
          $(".supercycle-human-icon-" + idx + "-" + i + " svg path").attr(
            "fill",
            "#F38336"
          );
          $(".supercycle-human-icon-" + idx + "-" + i).addClass("female");
        }

        $(".supercycle-human-icon-" + idx + "-" + progress).hover(
          function () {
            const tooltip = $(this).find(".tooltip");
            if (!tooltip.find(".tooltipContent").length) {
              tooltip.append(
                `<span class="tooltipContent">${tooltip.data("value")}</span>`
              );
            }
          },
          function () {
            $(this).find(".tooltip .tooltipContent").remove();
          }
        );
      }
      // }

      // if (pc > 0 && pc <= 100 && !completed) {
      //   console.log(idx + " animating");

      if (pc >= 100) {
        completed = true;
        console.log(idx + " completed");
      }
      // }
    }

    window.addEventListener("scroll", () => {
      animateIcons();
    });
  }

  var iconImage = "/themes/custom/tema/src/assets/supercycle/people-icon.svg";

  createGridCanvasWithIcons("gridCanvasOne", "animateHalfIcons", iconImage);
  createGridCanvasWithIcons(
    "gridCanvasTwo",
    "animateOneQuarterIcons",
    iconImage
  );
  // createGridCanvasWithIcons("gridCanvasThree", "animateThreeQuarterIcons", iconImage);
});
